var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlphabet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "none",
    x: "0px",
    y: "0px",
    width: "534px",
    height: "470px",
    viewBox: "0 0 534 470",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_1",
    gradientUnits: "userSpaceOnUse",
    x1: 765.025,
    y1: 669.9,
    x2: 957.275,
    y2: 669.9,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D56542"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DB4942"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_2",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 7.2000000000000455,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( 0.9999999999999937, 0, 0, 0.9999999999999937, 1117.95,285.35) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEC07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DBA115"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_3",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 409.5435389705226,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( -0.5981964716519025, 0.8013494751375426, -0.46155043850809063, -0.34452991336326727, 1510.05,208.5) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#566A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradient_4",
    gradientUnits: "userSpaceOnUse",
    cx: 0,
    cy: 0,
    r: 8.520636713297945,
    fx: 0,
    fy: 0,
    gradientTransform: "matrix( 0.7071067811865437, 0.7071067811865437, -0.7071067811865437, 0.7071067811865437, 1531.05,464.65) ",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_5",
    gradientUnits: "userSpaceOnUse",
    x1: 1540.8875,
    y1: 441.9375,
    x2: 1553.7124999999999,
    y2: 454.76250000000005,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFCC33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9933"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_6",
    gradientUnits: "userSpaceOnUse",
    x1: 1569.9875,
    y1: 471.3375,
    x2: 1587.7124999999999,
    y2: 468.4625,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0099F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#001FB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_7",
    gradientUnits: "userSpaceOnUse",
    x1: 1587.775,
    y1: 440.7375,
    x2: 1602.125,
    y2: 438.16249999999997,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6C0D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F89DBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCC355",
    stroke: "none",
    d: " M 969.2 659.2 L 957.3 659.6 956.9 680.25 957.3 680.25 956.9 680.65 969.2 679.55 969.2 659.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: " M 765.05 660.8 L 765.05 678.65 956.9 680.25 957.3 659.6 765.05 660.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_MEMBER_1_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F98257",
    stroke: "none",
    d: " M 1151.9 261.75 L 1138.4 264.5 1003.3 603.75 1018.65 600.15 1151.9 261.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC634D",
    stroke: "none",
    d: " M 1116.85 255.95 L 1106.9 280.7 1089 325.25 1081 345.15 980.05 602.3 1003.3 603.75 1138.4 264.5 1116.85 255.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEC95A",
    stroke: "none",
    d: " M 1133.35 253.8 L 1116.85 255.95 1138.4 264.5 1151.9 261.75 1133.35 253.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_0_MEMBER_2_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB6F3E",
    stroke: "none",
    d: " M 1093.5 135.5 L 1076.55 147.85 1176.8 604.85 1199.3 605.5 Q 1159.3 429.35 1119.3 253.15 1115.95 238.45 1112.6 223.8 L 1093.5 135.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC8345",
    stroke: "none",
    d: " M 1108.05 135.5 L 1093.5 135.5 1112.6 223.8 Q 1115.95 238.45 1119.3 253.15 1159.3 429.35 1199.3 605.5 L 1213.85 605.5 1108.05 135.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Symbol_1_0_Layer0_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_2)",
    stroke: "none",
    d: " M 1122.45 289.85 Q 1124.35 288 1124.35 285.35 1124.35 282.7 1122.45 280.8 1120.6 278.95 1117.95 278.95 1115.3 278.95 1113.4 280.8 1111.55 282.7 1111.55 285.35 1111.55 288 1113.4 289.85 1115.3 291.75 1117.95 291.75 1120.6 291.75 1122.45 289.85 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_1_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FA9046",
    stroke: "none",
    d: " M 1561.95 153.6 L 1559.15 135.5 1270.45 135.5 1274.65 153.6 1561.95 153.6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1351D",
    stroke: "none",
    d: " M 1545 161.2 L 1561.95 153.6 1274.65 153.6 1275.85 161.2 1545 161.2 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_2_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_3)",
    stroke: "none",
    d: " M 1623.7 482.3 L 1547.35 154.95 1273.8 155.65 1348.75 488.6 1623.7 482.3 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_3_MEMBER_0_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB6F3E",
    stroke: "none",
    d: " M 1093.5 135.5 L 1076.55 147.85 1176.8 604.85 1199.3 605.5 Q 1159.3 429.35 1119.3 253.15 1115.95 238.45 1112.6 223.8 L 1093.5 135.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC8345",
    stroke: "none",
    d: " M 1108.05 135.5 L 1093.5 135.5 1112.6 223.8 Q 1115.95 238.45 1119.3 253.15 1159.3 429.35 1199.3 605.5 L 1213.85 605.5 1108.05 135.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_3_MEMBER_1_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F98257",
    stroke: "none",
    d: " M 1151.9 261.75 L 1138.4 264.5 1003.3 603.75 1018.65 600.15 1151.9 261.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DC634D",
    stroke: "none",
    d: " M 1116.85 255.95 L 1106.9 280.7 1089 325.25 1081 345.15 980.05 602.3 1003.3 603.75 1138.4 264.5 1116.85 255.95 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEC95A",
    stroke: "none",
    d: " M 1133.35 253.8 L 1116.85 255.95 1138.4 264.5 1151.9 261.75 1133.35 253.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_3_MEMBER_3_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FCC355",
    stroke: "none",
    d: " M 969.2 659.2 L 957.3 659.6 956.9 680.25 957.3 680.25 956.9 680.65 969.2 679.55 969.2 659.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_1)",
    stroke: "none",
    d: " M 765.05 660.8 L 765.05 678.65 956.9 680.25 957.3 659.6 765.05 660.8 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_4_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_4)",
    stroke: "none",
    d: " M 1538.5 466.3 Q 1537.85 463.2 1535.2 460.55 1532.55 457.9 1529.4 457.2 1526.45 456.5 1524.7 458.15 L 1524.6 458.25 Q 1523 460 1523.6 463 1524.35 465.95 1526.65 468.45 L 1527.35 469.1 Q 1529.85 471.45 1532.7 472.1 1535.4 472.7 1537.05 471.5 1537.25 471.35 1537.5 471.1 1537.75 470.85 1537.95 470.6 1539.15 468.95 1538.5 466.3 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_5)",
    stroke: "none",
    d: " M 1557.8 428.8 Q 1554.85 428.15 1553.1 429.75 L 1524.7 458.15 Q 1526.45 456.5 1529.4 457.2 1532.55 457.9 1535.2 460.55 1537.85 463.2 1538.5 466.3 1539.15 468.95 1537.95 470.6 L 1566.35 442.2 Q 1567.5 440.6 1566.9 437.9 1566.25 434.8 1563.6 432.15 1560.95 429.5 1557.8 428.8 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_6)",
    stroke: "none",
    d: " M 1582.85 438.65 Q 1582.4 438.1 1580.75 436.75 1577.95 434.35 1574.4 435 1570.8 435.7 1569 438.9 1567.85 440.65 1567.45 441.45 1566.8 442.75 1567 444.35 L 1567.1 444.35 1572.55 474.05 1589.5 470.95 1584.05 441.25 Q 1583.7 439.6 1582.85 438.65 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Gradient_7)",
    stroke: "none",
    d: " M 1582.15 417.65 L 1582.25 417.65 1592.2 472.3 1609.15 469.2 1599.2 414.55 Q 1598.85 412.95 1598.05 411.95 1597.6 411.4 1595.9 410.05 1593 407.7 1589.55 408.3 1586.05 408.95 1584.15 412.2 1582.95 413.9 1582.6 414.75 1581.95 416.1 1582.15 417.65 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_5_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1351D",
    stroke: "none",
    d: " M 1354.65 502 L 1341.45 509.55 1398.55 508.7 1655.95 500.4 1672.6 492.2 1398.55 501.55 1354.65 502 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5463E",
    stroke: "none",
    d: " M 1349.9 484.25 L 1336.45 490.55 1341.45 509.55 1354.65 502 1349.9 484.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA9046",
    stroke: "none",
    d: " M 1350.35 484.05 L 1349.9 484.25 1354.65 502 1398.55 501.55 1672.6 492.2 1669.2 474.2 1398.55 483.4 1350.35 484.05 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer0_0_MEMBER_6_FILL"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC9DBE",
    stroke: "none",
    d: " M 1557.25 268.55 Q 1555.4 267 1552.9 266.05 1550.5 265.15 1547.75 265.2 1542.7 265.35 1538.25 266 1533.7 266.55 1529.9 267.55 1526.05 268.4 1523.05 269.55 1519.95 270.7 1517.85 271.85 1515.7 273.05 1514.55 274.25 1513.4 275.35 1513.45 276.3 1513.45 277.35 1514.1 278.1 1514.65 278.9 1515.25 278.9 1515.6 278.85 1515.95 278.85 1516.25 278.8 1516.55 278.8 1517.1 278.8 1517.55 278.85 1518.05 278.95 1518.4 279.3 1518.75 279.6 1518.95 280.15 1519.1 280.75 1519.15 281.85 1519.15 281.9 1519 283.65 1518.85 285.4 1518.65 288.2 1518.4 290.9 1518.05 294.4 1517.7 297.85 1517.35 301.5 1516.9 305.1 1516.45 308.55 1515.95 312 1515.4 314.65 1514.9 317.25 1514.65 318.65 1514.35 320 1514.35 320.7 1514.35 321.25 1514.6 322.25 1514.75 323.2 1515.25 324.15 1515.7 325.1 1516.3 325.8 1516.95 326.45 1517.8 326.45 1518.95 326.4 1519.95 326.15 1520.95 325.85 1521.6 325.25 1522.2 324.55 1522.6 323.55 1522.9 322.55 1522.85 320.95 1522.8 319.7 1522.7 318.3 1522.45 316.9 1522.4 315.45 1522.4 314.7 1522.55 312.8 1522.7 310.9 1523 308.3 1523.2 305.6 1523.6 302.5 1523.9 299.3 1524.35 296.1 1524.8 292.75 1525.2 289.6 1525.55 286.4 1525.9 283.65 1526.3 280.95 1526.6 279 1526.9 276.95 1527.1 276.05 1527.15 275.45 1528.15 274.95 1529.15 274.4 1530.7 273.95 1532.2 273.4 1534.15 272.95 1536.05 272.55 1538.1 272.2 1540 271.85 1541.95 271.65 1543.85 271.45 1545.35 271.4 1547.5 271.3 1549.05 271.75 1550.6 272.25 1551.55 272.95 1552.6 273.7 1553.05 274.7 1553.55 275.6 1553.55 276.5 1553.6 277.4 1553.05 278.65 1552.4 279.9 1551.45 281.25 1550.45 282.65 1549.1 284.15 1547.75 285.55 1546.2 287 1544.65 288.35 1543.05 289.6 1541.5 290.8 1539.95 291.75 1538.85 292.45 1537.3 293.15 1535.7 293.8 1534.3 294.55 1532.85 295.15 1531.85 295.85 1530.8 296.55 1530.8 297.2 1530.85 298.35 1531.1 299.05 1531.35 299.65 1531.85 300.05 1532.35 300.45 1533.25 300.55 1534.1 300.65 1535.5 300.6 1536.05 300.6 1537.1 300.15 1538.15 299.75 1539.3 299.25 1540.4 298.7 1541.4 298.25 1542.4 297.85 1542.95 297.85 1546 297.75 1548.2 298.7 1550.35 299.6 1551.8 301.05 1553.25 302.55 1553.95 304.2 1554.65 305.9 1554.7 307.35 1554.75 309.25 1553.9 310.95 1552.95 312.75 1551.5 314.25 1550 315.75 1548.1 317 1546.2 318.2 1544.25 319.05 1542.35 319.95 1540.55 320.45 1538.8 320.95 1537.55 321 1536.6 321.05 1535.65 321 1534.75 321 1533.9 321 1532.45 321.05 1531.25 321.4 1529.95 321.7 1529 322.3 1528.15 322.95 1527.6 323.85 1527.1 324.8 1527.1 326.15 1527.15 326.65 1527.9 327.1 1528.65 327.55 1529.7 327.85 1530.8 328.15 1531.85 328.4 1532.85 328.5 1533.45 328.5 1537.65 328.35 1541.4 327.1 1545.15 325.85 1548.3 323.85 1551.45 321.9 1553.95 319.45 1556.5 317.05 1558.25 314.65 1560 312.25 1560.85 310.1 1561.8 308 1561.75 306.6 1561.7 304.55 1561.3 303 1560.85 301.4 1560.25 300.15 1559.6 299 1558.85 298.15 1558.1 297.35 1557.35 296.7 1556.5 295.9 1555.15 295.25 1553.75 294.55 1552.45 294 1551.1 293.45 1550.2 292.95 1549.25 292.45 1549.25 292.05 1551.7 289.9 1553.95 287.5 1556.15 285.15 1557.8 282.85 1559.45 280.6 1560.45 278.75 1561.4 276.8 1561.35 275.55 1561.3 273.75 1560.25 271.95 1559.1 270.1 1557.25 268.55 M 1454.55 267.5 Q 1452.75 267.2 1451.45 266.8 1450.15 266.4 1449.15 266.05 1448.2 265.75 1447.4 265.8 1446.15 265.8 1445.35 266.85 1444.5 267.85 1444 269.4 1443.5 270.9 1443.3 272.65 1443 274.4 1442.95 276 1442.85 277.5 1442.85 278.6 1442.8 279.65 1442.8 279.75 1442.15 285.2 1441.25 291 1440.3 296.7 1439.95 302.35 1439.7 304.9 1439.55 307.1 1439.4 309.3 1439.3 311.25 1439.15 313.25 1439.1 315.1 1439.05 316.95 1439.15 318.9 1439.15 319.6 1439.2 320.4 1439.25 321.15 1439.25 321.95 1439.3 322.9 1439.1 323.7 1438.85 324.55 1438.6 325.3 1438.3 326.05 1438.1 326.8 1437.85 327.55 1437.85 328.35 1437.85 328.75 1438.35 329.25 1438.75 329.75 1439.45 330.2 1440.1 330.65 1440.9 330.95 1441.65 331.2 1442.3 331.2 1443.55 331.15 1444.55 330.7 1445.4 330.25 1446.45 329.45 1446.9 329.1 1447.25 328.55 1447.6 327.9 1447.7 327.8 1449.75 327.15 1452.3 326.45 1454.9 325.65 1457.8 324.75 1460.75 323.85 1463.75 322.7 1466.85 321.5 1469.7 320 1472.55 318.55 1475.05 316.7 1477.6 314.9 1479.5 312.55 1481.3 310.25 1482.4 307.5 1483.4 304.6 1483.3 301.2 1483.15 296.95 1481.7 294.3 1480.15 291.55 1477.8 290 1475.45 288.4 1472.55 287.85 1469.5 287.3 1466.45 287.4 1465.65 287.4 1464.35 287.55 1463.1 287.7 1461.65 287.9 1460.2 288.1 1458.7 288.5 1457.2 288.8 1455.95 289.25 1454.8 289.7 1453.7 290.1 1452.55 290.55 1451.55 290.9 1450.6 291.25 1449.9 291.5 1449.1 291.7 1448.65 291.7 1448.3 291.7 1448.15 291.65 1447.9 291.5 1447.85 291.35 1447.8 291.2 1447.8 291.05 1447.8 290.9 1447.8 290.85 1448.05 289.7 1448.3 288.4 1448.4 287.1 1448.55 285.85 1448.65 284.6 1448.85 283.45 1449 282.35 1449.25 281.4 1449.5 280.15 1449.8 278.75 1450.05 277.4 1450.45 276.35 1450.7 275.25 1451 274.55 1451.35 273.8 1451.75 273.8 1451.95 273.8 1452.3 273.9 1452.65 273.95 1453.1 273.95 1453.5 274 1453.85 274.1 1454.2 274.1 1454.4 274.15 1455.2 274.2 1456.4 274.3 1457.65 274.4 1459 274.45 1460.35 274.5 1461.8 274.55 1463.25 274.5 1464.65 274.45 1465.4 274.45 1466.75 274.35 1468.1 274.15 1469.65 273.9 1471.25 273.6 1472.95 273.15 1474.6 272.6 1475.95 271.85 1477.3 271 1478.1 269.9 1479 268.8 1478.95 267.3 1478.9 266.75 1478.5 266.35 1478.15 266 1477.6 265.8 1477 265.55 1476.4 265.4 1475.65 265.35 1475.1 265.35 1474.85 265.35 1474.35 265.55 1473.8 265.7 1473.15 265.9 1472.5 266.15 1471.95 266.35 1471.4 266.5 1471.2 266.5 1470 266.6 1468.5 266.85 1467 267.05 1465.35 267.25 1463.7 267.4 1462.1 267.6 1460.35 267.7 1458.85 267.75 1456.35 267.8 1454.55 267.5 M 1452.1 296.55 Q 1454 295.8 1456.25 295.25 1458.5 294.6 1460.8 294.25 1463.2 293.9 1465.5 293.8 1468.55 293.7 1470.75 294.35 1472.85 295 1474.25 296.25 1475.55 297.45 1476.2 299.15 1476.85 300.85 1476.9 302.85 1476.9 303.9 1476.6 305 1476.25 306.15 1475.6 307.3 1475 308.4 1474.1 309.45 1473.2 310.45 1472.15 311.3 1470.4 312.65 1468.3 313.85 1466.2 315.05 1463.9 316.15 1461.65 317.2 1459.3 318 1457.05 318.9 1454.9 319.55 1453.9 319.85 1452.7 320.1 1451.45 320.4 1450.25 320.6 1449.05 320.8 1448.05 320.85 1447.1 321 1446.65 321 1446.4 320.65 1446.2 320.05 1446.05 319.45 1445.95 318.75 1445.8 318.05 1445.75 317.3 1445.65 316.6 1445.65 316.05 1445.6 314.6 1445.6 312.85 1445.6 311.05 1445.7 309.25 1445.8 307.4 1446.05 305.65 1446.25 303.85 1446.6 302.35 1446.95 300.85 1447.5 299.75 1448.05 298.65 1448.7 298.15 1450.15 297.3 1452.1 296.55 M 1379.95 268.05 Q 1378.85 268.1 1377.3 270 1375.7 271.85 1373.9 274.8 1372.15 277.75 1370.25 281.35 1368.3 285 1366.55 288.55 1364.75 292.1 1363.2 295.25 1361.6 298.35 1360.45 300.25 1356.7 306.6 1353.7 311.15 1350.7 315.65 1348.65 318.7 1346.55 321.75 1345.5 323.65 1344.4 325.55 1344.4 326.6 1344.45 327.35 1344.95 328 1345.5 328.7 1346.2 329.25 1346.85 329.75 1347.65 330.1 1348.4 330.4 1348.95 330.4 1350.05 330.35 1351.2 329.1 1352.3 327.8 1353.45 325.9 1354.55 323.95 1355.65 321.8 1356.7 319.55 1357.7 317.7 1358.7 315.8 1359.65 314.5 1360.5 313.25 1361.25 313.2 1361.8 313.2 1362.5 313.45 1363.15 313.7 1364.15 313.7 1364.85 313.65 1366.3 313.25 1367.8 312.85 1369.45 312.4 1371.05 311.9 1372.5 311.5 1373.95 311 1374.65 310.8 1376.5 310.3 1378.85 309.85 1381.2 309.35 1383.35 309 1385.5 308.6 1387.15 308.35 1388.85 308.05 1389.4 308.05 1389.65 308 1390.1 308.55 1390.5 309.05 1390.95 309.9 1391.45 310.7 1392.05 311.8 1392.55 312.9 1393.15 313.95 1393.7 315.05 1394.25 316.05 1394.75 317.1 1395.15 317.75 1395.8 319 1396.8 320.55 1397.8 322.15 1398.95 323.9 1400.1 325.6 1401.4 327.25 1402.65 328.85 1403.95 330.2 1405.2 331.5 1406.5 332.25 1407.75 333.05 1408.9 333 1409.7 333 1410.4 332.6 1411.1 332.1 1411.6 331.45 1412.1 330.8 1412.4 329.85 1412.65 328.95 1412.6 328 1412.6 327.15 1412.05 326.3 1411.6 325.4 1410.75 324.45 1410 323.6 1408.9 322.6 1407.85 321.7 1406.6 320.65 1405.4 319.65 1403.95 317.6 1402.5 315.55 1401.1 313.15 1399.65 310.7 1398.5 308.35 1397.2 305.95 1396.5 304.35 1395.3 301.6 1394.15 298.8 1392.95 295.9 1391.95 293.2 1390.85 290.5 1389.85 288.05 1388.85 285.6 1387.95 283.55 1387.3 282.2 1386.8 280.85 1386.2 279.4 1385.8 278.1 1385.35 276.8 1385 275.8 1384.6 274.7 1384.35 274.05 1384.7 272.95 1384.65 271.4 1384.65 270.7 1384.55 270.15 1384.4 269.6 1384.2 269.4 1383.35 268.55 1382.35 268.35 1381.2 268.05 1379.95 268.05 M 1378.65 279.3 Q 1378.9 279.5 1379.55 281 1380.2 282.5 1381.05 284.6 1381.95 286.8 1382.95 289.35 1383.95 292 1384.85 294.4 1385.8 296.8 1386.6 298.75 1387.35 300.75 1387.75 301.65 1385.5 302 1383.15 302.5 1380.8 303 1378.55 303.55 1376.4 304 1374.45 304.45 1372.45 304.95 1370.9 305.1 1370.2 305.25 1369.3 305.35 1368.4 305.5 1367.5 305.7 1366.6 305.85 1365.9 306.05 1365.15 306.25 1364.85 306.5 1366.4 303.2 1368.3 299.7 1370.15 296.2 1372.05 292.7 1373.9 289.1 1375.65 285.75 1377.4 282.4 1378.65 279.3 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -447.1,-263.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_MEMBER_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -679.85,-135.5) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_MEMBER_1_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -679.85,-135.5) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_0_MEMBER_2_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 487.3,400.25) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1111.55,-278.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 327.8,399.45) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1111.55,-278.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1143.05,-135.5) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_1_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1140.7,-132) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_2_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -980.05,-135.5) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_3_MEMBER_0_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -980.05,-135.5) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_3_MEMBER_1_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 131.5,143.45) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1111.55,-278.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -750.4,-263.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_3_MEMBER_3_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 187.1,400.25) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1111.55,-278.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, 27.6,399.45) "
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1111.55,-278.95) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Symbol_1_0_Layer0_0_FILL"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1137.25,-136.8) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_4_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1145.7,-143.15) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_5_FILL"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix( 1, 0, 0, 1, -1150.75,-137.5) "
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Layer0_0_MEMBER_6_FILL"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabet);
export default __webpack_public_path__ + "static/media/alphabet.2c15392a9054c842cbe16cb0cf3962c9.svg";
export { ForwardRef as ReactComponent };